export default {
  Services: 'الخدمات',
  'Number of applications': 'عدد التطبيقات',
  'Number of devices': 'عدد الأجهزة',
  'Read more': 'اقرأ المزيد',
  'Website requirements': 'متطلبات الموقع الإلكتروني',
  'Website URL': 'رابط صفحة الدفع',
  'I need web integration': 'أحتاج إلى الربط التقني مع الويب',
  'Select plugin': 'اختر المكون الإضافي',
  'Select method': 'اختر الطريقة',
  'Fees and charges*': 'الرسوم والتكاليف*',
  'Additional services*': 'خدمات إضافية*',
  Free: 'مجاني',
  'Payment Schemes*': 'خطط الدفع*',
  '*These fees are subject to 15% VAT.': '*تخضع هذه الرسوم لضريبة القيمة المضافة بنسبة 15٪.',
  'Acceptance of Canada and USA cards require extra approval. Are you selling to Canada or USA? Request a call with sales.': 'يتطلب قبول بطاقات كندا والولايات المتحدة موافقة إضافية. هل تبيع إلى كندا أو الولايات المتحدة؟ اطلب مكالمة مع قسم المبيعات.',
  'Reset to default': 'إعادة تعيين إلى الافتراضي',
  'Default pricing:': 'التسعير الافتراضي:',
  'Callback is requested': 'تم طلب معاودة الاتصال',
  'Special pricing applied': 'تم تطبيق تسعير خاص',
  'Total for all applications': 'الإجمالي لجميع التطبيقات',
  'Total for all terminals': 'الإجمالي لجميع الأجهزة الطرفية',
  'General configurations': 'التكوينات العامة',
  'Request a callback': 'طلب معاودة الاتصال',
  'Please enter you message in the field below. We will contact you as soon as possible.': 'يرجى إدخال رسالتك في الحقل أدناه. سنتواصل معك في أقرب وقت ممكن.',
  'Your message': 'رسالتك',
  'Contact me': 'اتصل بي',
  'Company request': 'طلب شركة',
};
